// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__3OC6-","password":"PasswordResetForm_password__1Dc_q"};